{
  "helpMessage": "<h3>Got questions?</h3><p>We’re happy to help - call our team:<br/><a><strong>☎️ {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am–5pm.</p>",
  "title": "Invitation is not valid"
}
